import React from 'react'

import { Link } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'

import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import TablePagination from '@material-ui/core/TablePagination'
import Skeleton from '@material-ui/lab/Skeleton'
import moment from 'moment'

import { routes } from 'routes'
import { Container, ContentHeader, TableHeader, Filters } from 'components'
import * as service from 'service'
import ContractsTable from './components/ContractsTable'

import { Permitted } from 'components/Permissions'
import usePagination from 'hooks/usePagination'
import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'

const ContractsMain = () => {
  const filter = useFilter()

  const {
    perPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
  } = usePagination(20)

  const { response, isLoading } = useFetch(
    service.recurrence.contracts.get,
    { perPage, page, ...{ contract: { ...filter.filters } } },
    [page, perPage, filter.filters],
  )

  return (
    <Container>
      <ContentHeader title="Assinaturas" subtitle="Listagem">
        <Permitted tag="complete_contract">
          <Button
            component={Link}
            to={routes.contracts.new}
            variant="contained"
            color="primary"
          >
            Criar
          </Button>
        </Permitted>
      </ContentHeader>

      <Paper>
        <TableHeader
          setDrawerOpen={filter.setDrawerOpen}
          downloadable={true}
          fnDownload={service.recurrence.contracts.downloadCsv}
          paramsDownload={{
            perPage,
            page,
            ...{ contract: { ...filter.filters } },
          }}
          fileName={
            'Assinaturas_' +
            moment(new Date())
              .utc(false)
              .format('DD-MM-YYYY') +
            '.csv'
          }
        />

        <PerfectScrollbar>
          <ContractsTable
            contracts={response && response.data.contracts}
            isLoading={isLoading}
          />
        </PerfectScrollbar>

        <Box px={2} display="flex" justifyContent="flex-end">
          {response ? (
            <TablePagination
              component="div"
              count={response.data.meta.totalCount}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
              labelRowsPerPage="Por página"
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          ) : (
            <Box py="11px">
              <Skeleton variant="rect" width={200} height={30} />
            </Box>
          )}
        </Box>
      </Paper>

      <Filters filter={filter}>
        <input textfieldinput="true" label="Identificador" name="id" />
        <input textfieldinput="true" label="Código" name="code" />
        <input
          textfieldinput="true"
          label="Identificador do cliente"
          name="customerId"
        />
        <input
          textfieldinput="true"
          label="Nome ou e-mail do cliente"
          name="customer[nameOrEmail]"
        />
        <input
          textfieldinput="true"
          label="Código do plano"
          name="contractPlans[planCode]"
        />
        <select textfieldinput="true" label="Status" name="status">
          <option value=""></option>
          <option value="2">Ativo</option>
          <option value="1">Pendente</option>
          <option value="3">Inativo</option>
          <option value="4">Inadimplente</option>
          <option value="5">Cancelado</option>
          <option value="6">Finalizado</option>
        </select>
        <select textfieldinput="true" label="Tipo de cobrança" name="postPaid">
          <option value=""></option>
          <option value="true">Pós paga</option>
          <option value="false">Pré paga</option>
        </select>
        <input
          textfieldinput="true"
          label="Dia de faturamento"
          name="dayExpiration"
        />
        <input
          datepickerinput="true"
          label="Data de criação inicial"
          name="createdAtGt"
        />
        <input
          datepickerinput="true"
          label="Data de criação final"
          name="createdAtLt"
        />
      </Filters>
    </Container>
  )
}

export default ContractsMain
